import { useSelector } from "react-redux";
import { sumOfRecordCountsWithoutDecimal } from "../../../helper/utility";
import { Constants } from "../../Common/Constants";
import AreaGraph from "../../Common/Graphs/AreaGraph";

const Weekly = () => {
  // const { workoutanalytics } = useSelector((store) => store.Reports);
  const userStrengthAssessment = useSelector((store) => store.WorkOutAnalyticsReportReducer.exerciseWiseStrengthAssessmentReport);
  const sumOfUserStrengthAssessment = sumOfRecordCountsWithoutDecimal(userStrengthAssessment);


  return (
    <div className="row mt-4">
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={workoutanalytics?.userStrengthAssessment}
          data={userStrengthAssessment}
          // title={Constants.strengthAssessment}
          title={`${Constants.strengthAssessment} ${sumOfUserStrengthAssessment}`}
          format=""
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Weekly;
